import type { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const collapseDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Checks whether the component is expanded and the content is visible
     * @return {Promise<boolean>}
     */
    isOpen: async () => (await base.attr('data-open')) === 'true',
  };
};
